import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import StockDetails from './StockDetails';

const ConfiguratorStock = () => {
  const onHandModel = useSelector((state) => state.configurator.onHandModel),
    totalWeight = useSelector((state) => state.configurator.totalWeight),
    stackedPrices = useSelector((state) => state.configurator.stackedPrices),
    isStandAlone = useSelector((state) => state.configurator.isStandAlone),
    factorKg = stackedPrices ? stackedPrices.factorKg : null;

  if (!onHandModel) {
    return <div>{translate('config.onhand.missing')}</div>;
  }

  return (
    <div className='configurator-box'>
      <div className='configurator-box__content'>
        <div className='onhand'>
          <div className='onhand__title'>{translate('config.larger')}</div>
          <div>
            <StockDetails
              variantSystemId={onHandModel.variantSystemId}
              stockArticle={onHandModel}
              articleWeight={totalWeight}
              articleFactorKg={factorKg}
              isStandAlone={isStandAlone}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfiguratorStock;
